import { urlBuilder } from '@/api/utils';
import {
    ProductPersonNameConfiguration,
    ProductTextReplacement,
    TextReplacement,
    TextReplacementIndex,
    transformTrToTrIndex,
} from '@/models/textReplacement';
import { baseApiAuthenticated } from '@/api/v2/index';

export const textReplacementUrls = (id: string) => ({
    textReplacements: urlBuilder(
        'liftoperators',
        `liftoperators/${id}/textreplacements`
    ),
    backendConfiguration: urlBuilder(
        'liftoperators',
        `liftoperators/${id}/backend-configuration`
    ),
});

type TextReplacementApiData = {
    liftOperatorId: string;
    textReplacements: TextReplacement[];
    productTextReplacements: ProductTextReplacement[];
};

export const textReplacementApi = baseApiAuthenticated.injectEndpoints({
    endpoints: (builder) => ({
        getTextReplacement: builder.query<
            {
                textReplacementIndex: TextReplacementIndex;
                productTextReplacements: ProductTextReplacement[];
            },
            { liftOperatorId: string }
        >({
            query: ({ liftOperatorId }) => ({
                url: textReplacementUrls(liftOperatorId).textReplacements,
            }),

            transformResponse: (response: TextReplacementApiData) => {
                return {
                    textReplacementIndex: transformTrToTrIndex(
                        response.textReplacements
                    ),
                    productTextReplacements: response.productTextReplacements,
                };
            },
        }),

        postTextReplacements: builder.mutation<boolean, TextReplacementApiData>(
            {
                query: ({ liftOperatorId, ...rest }) => ({
                    url: textReplacementUrls(liftOperatorId).textReplacements,
                    method: 'POST',
                    body: {
                        liftOperatorId,
                        ...rest,
                    },
                }),
            }
        ),

        getProductPersonNameConfiguration: builder.query<
            ProductPersonNameConfiguration,
            string
        >({
            query: (id) => ({
                url: textReplacementUrls(id).backendConfiguration,
            }),
        }),
    }),
});

export const {
    useGetTextReplacementQuery,
    useLazyGetTextReplacementQuery,
    usePostTextReplacementsMutation,
    useGetProductPersonNameConfigurationQuery,
} = textReplacementApi;
